<template>
  <div class="header">
    <div class="header__info info">
      <i
        v-if="user.authenticated"
        class="fa fa-bars menu-toggle-button"
        @click="$parent.toggleMenu()"
      />
      <router-link
        v-if="user.authenticated"
        class="info__logo"
        to="/"
        exact
      />
      <router-link
        v-else
        class="info__logo no-menu"
        to="/login"
        exact
      />
      <div class="info__contact contact">
        <div class="info__customer-support desktop">
          <span>
            {{ $t('header.client_support') }}
            <a
              class="contact__home orange"
              :href="'tel:' + phone"
            >{{ phone }}</a>
            <span>/</span>
            <a
              class="contact__email"
              :href="'email:' + email"
            >{{ email }}</a>
          </span>
        </div>
        <div class="info__lang group">
          <a
            v-for="locale in locales"
            :href="locale"
            :class="[{ active: $i18n.locale === locale }, 'icon-lang-' + (locale == 'et' ? 'ee' : locale)]"
            @click.prevent="changeLocale(locale)"
          />
        </div>
      </div>
      <span class="info__customer-support mobile">
        <span>
          {{ $t('header.client_support') }}
          <a
            class="contact__home orange"
            :href="'tel:' + phone"
          >{{ phone }}</a>
          <span>/</span>
          <a
            class="contact__email"
            :href="'email:' + email"
          >{{ email }}</a>
        </span>
      </span>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import { mapGetters } from 'vuex';
import moment from 'moment';

export default {
  data() {
    return {
      locales: process.env.LANGUAGES,
      phone: process.env.CUSTOMER_SUPPORT_PHONE,
      email: process.env.CUSTOMER_SUPPORT_EMAIL,
    };
  },
  computed: mapGetters({
    user: 'user/user/user',
  }),
  methods: {
    changeLocale(locale) {
      this.$i18n.locale = locale;
      Vue.http.headers.common['X-Locale'] = locale;
      localStorage.setItem('locale', locale);
      moment.locale(locale);
    },
  },
};
</script>

<style lang="scss" scoped>

@import '~styles/app.scss';

.header {
  font-size: 14px;
  background-color: var(--white);
}

.header__info {
  align-items: center;
  height: 100px;
  padding-right: 30px;
  filter: drop-shadow(4px 4px 4px rgba(0, 0, 0, 0.1));
  box-shadow: 0 .5px 1px rgba(0,0,0,0.04), 0 1px 2px rgba(0,0,0,0.05);

  .menu-toggle-button {
    font-size: 14px;
    width: 30px;
    height: 30px;
    position: absolute;
    top: 25px;
    left: 29px;
    color: var(--grey-five);
    line-height: 30px;
    text-align: center;
    cursor: pointer;
    display: none;

    @media screen and (max-width: 520px) {
      display: block;
    }

  }

  .info__customer-support {

    &.desktop {
      display: none;

      @media screen and (min-width: 850px) { /* 801 */
        display: block;
      }

    }

    &.mobile {
      display: none;

      @media screen and (max-width: 800px) {
        display: none; /* TODO: fix to work with sticky panels */
        position: fixed;
        bottom: 0;
        background: white;
        width: 100vw;
        padding: 15px;
        text-align: center;
        @include shadow(2);
        padding: 15px 25px;
        z-index: 9999;
      }
    }
  }

  .contact {
    display: flex;
    justify-content: flex-end;

    @media screen and (max-width: 370px) {
      margin-top: 35px;
    }

  }

  .contact__home {
    margin-left: 7px;
  }
  .contact__email {
    color: #000;
  }

  .info__lang {
    float: right;
    margin-left: 12px;

    a {
      display: block;
      width: 19px;
      height: 20px;
      float: left;
      margin-left: 13px;
      opacity: 0.4;
      transition: all 225ms ease-in-out;
      filter: drop-shadow(2px 2px 4px rgba(0, 0, 0, 0.1));

    }

    a:hover {
      transition: all 225ms ease-in-out;
      opacity: 0.85;
      filter: drop-shadow(2.5px 2.5px 5px rgba(0, 0, 0, 0.21)) contrast(200%);
      transform: scale(1.05);
    }

    a.active {

      transition: all 225ms ease-in-out;
      opacity: 1;
      filter: drop-shadow(2.5px 2.5px 5px rgba(0, 0, 0, 0.1)) contrast(200%);
      animation: jumpInOut 225ms ease-in-out;
    }

  }
}
.info__logo {
  background: url('~assets/ep-logo.svg') no-repeat;
  background-size: 162px 53px;
  display: block;
  width: 162px;
  height: 53px;
  margin-left: 31px;
  position: relative;
  top: 30px;
  left: 37px;
  transition: all 500ms ease-in-out;

  @media screen and (max-width: 520px) {
    /* left: 0; */
    height: 30px;
    width: 91.6981px;
    background-size: 91.6981px 30px;

    &.no-menu {
      margin-left: 0;
    }
  }

}

.europark-pl,
.europark-fi {
  .info__logo {
    background: url("~assets/ep-logo-new.svg") no-repeat left center;
    background-size: contain;
    @media screen and (max-width: 520px) {
      width: 100%;
    }
  }
}

.spinn {
  .info__logo {
    background: url('~assets/spinn-logo.svg') no-repeat;
    background-size: contain;
    background-position: left center;
    width: 231px;
    height: 41px;

    @media screen and (max-width: 520px) {
      height: 30px;
      width: 116px;
    }

  }

}

.hepsor {
  .info__logo {
    background: url('~assets/hepsor-logo.svg') no-repeat;
    background-size: contain;
    background-position: left center;
    width: 231px;
    height: 41px;

    @media screen and (max-width: 520px) {
      height: 30px;
      width: 116px;
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/common/LayoutHeader.vue